module.exports = __webpack_public_path__ + "assets/subref.svg";